import { Fitter, LocationData } from '../commons';
import { BottomSheetData } from './bottom-sheet-data';

export interface MapAppsData extends BottomSheetData {
  userAddress: LocationData;
  fitter: Fitter;
}
